export default __webpack_public_path__ + "static/line-with-gaps-81caa5eab16e3014b1d6d38cc853f5a5.png";